<template>
  <div class="register-page">
    <Register />
  </div>
</template>

<script>
import { Register } from '@/features/register';

export default {
  components: { Register },
};
</script>
